import React, { useCallback, useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Select,
  Space,
  Table,
  Tag,
  Card,
  Row,
  Col,
  Image,
  TreeSelect,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { AiFillDelete } from "react-icons/ai";

import { useSelector, useDispatch } from "react-redux";
import { blogActions } from "../../store";
import { LocalImage } from "../../components/ImageUtil";

import debounce from "lodash.debounce";
import categoryApi from "../../api/blog/categoryApi";
import ENV from "../../consts/config";
import { list_to_tree } from "../../utils/index";
import blogApi from "../../api/blog/blogApi";
const Article = (props) => {
  const [form] = Form.useForm();
  const { Option } = Select;
  const dispatch = useDispatch();
  const confirm = Modal.confirm;
  const { TreeNode } = TreeSelect;
  const [treeLine, setTreeLine] = useState(true);
  const [showLeafIcon, setShowLeafIcon] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [valueForm, setValueForm] = useState();
  const [btnDeleted, setBtnDeleted] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [listDeleted, setListDeleted] = useState([]);

  const [inputFilter, setFilter] = useState({
    title: null,
    published: true,
    sortBy: "createdAt:desc",
    page: 1,
    limit: 10,
  });

  const { lstBlog, totalCountBlog } = useSelector((x) => x.blog);
  const [categorySelect, setCategorySelect] = useState([]);

  useEffect(() => {
    getBlog();
    getCategorySelect();
    form.setFieldsValue(valueForm);
  }, [inputFilter, valueForm]);

  const handleSearch = (e) => {
    setFilter({ ...inputFilter, page: 1, title: e.target.value });
  };

  const getCateDebounce = useMemo(() => debounce(handleSearch, 300), []);

  const getBlog = () => {
    setLoading(true);
    dispatch(blogActions.getBlogs(inputFilter)).then(() => {
      setLoading(false);
    });
  };

  const getCategorySelect = () => {
    const params = { display: true, page: 1, limit: 10000 };
    categoryApi.getCategories(params).then((res) => {
      if (res) {
        const cate = res?.results.map((item) => {
          return {
            title: item.name,
            value: item.id,
            id: item.id,
            parentId: item.parent?.id || "0",
            parentName: item.parent?.name || "",
            children: null,
          };
        });
        cate.unshift({
          title: "Chuyên mục gốc",
          value: "0",
          id: "0",
          children: null,
          parentId: "0",
        });
        const list = list_to_tree(cate);
        setCategorySelect(list);
      }
    });
  };

  function onChange(pagination, filters, sorter, extra) {
    setPageSize(pagination.pageSize);
    if (pagination && pagination.current) {
      setPage(pagination.current);
    }
    // let sort = "createdAt:desc";
    // if (sorter && sorter.columnKey) {
    //   let order = "ASC";
    //   if (sorter.order === "descend") {
    //     order = "DESC";
    //   }
    //   sort = sorter.columnKey + " " + order;
    // }
    setFilter({
      name: inputFilter.name,
      published: inputFilter.published,
      displayHome: inputFilter.displayHome,
      sortBy: inputFilter.sortBy,
      limit: pagination.pageSize,
      page: pagination.current,
    });
  }

  const columns = [
    {
      title: "STT",
      render: (text, record, index) => (page - 1) * pageSize + index + 1,
      className: "text-center",
      width: "5%",
    },
    {
      title: "Lượt xem",
      className: "text-center",
      dataIndex: "view",
      width: "5%",
      render: (view) => <h6>{view}</h6>,

    },
    {
      title: "Ảnh hiển thị",
      dataIndex: "avatar",
      key: "avatar",
      render: (avatar) => (
        <>
          <LocalImage
            src={avatar}
            width={100}
            style={{ objectFit: "contain" }}
            height={100}
          />
        </>
      ),
      width: 150,
      className: "text-center",
    },

    {
      title: "Tên bài viết",
      dataIndex: "title",
      render: (text) => <h6>{text}</h6>,
      width: 350,
      className: "whiteSpace-nowrap",
    },
    {
      title: "Danh mục",
      dataIndex: "category",
      render: (category) => <label>{category?.name}</label>,
      width: 150,
      className: "whiteSpace-nowrap",
    },
    {
      title: "Slug",
      dataIndex: "slug",
      render: (text) => <span>{text}</span>,
      className: "whiteSpace-nowrap",
      width: 250,
    },
    {
      title: "Trạng thái",
      dataIndex: "published",
      render: (display) => (
        <>
          {display === true && (
            <Tag color="green" key={display}>
              Hoạt động
            </Tag>
          )}
          {display === false && (
            <Tag color="red" key={display}>
              Không hoạt động
            </Tag>
          )}
        </>
      ),
      className: "text-center",
      width: 50,
    },
    {
      title: "Hành động",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Link to={`/article/edit/` + record.id}>
            <Button
              // onClick={() => showEditModal(record)}
              value="large"
              icon={<EditOutlined />}
            >
              Sửa
            </Button>
          </Link>
          <Button
            value="large"
            type="primary"
            icon={<DeleteOutlined />}
            danger
            onClick={() => deleteBlog(record)}
          >
            Xóa
          </Button>
        </Space>
      ),
      width: 150,
      className: "text-center",
      fixed: "right",
    },
  ];

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    console.log(
      `selectedRowKeys: ${newSelectedRowKeys}`,
      "selectedRows: ",
      selectedRows
    );
    setSelectedRowKeys(newSelectedRowKeys);
    if (newSelectedRowKeys.length > 0) {
      setListDeleted(`${newSelectedRowKeys}`);
      setBtnDeleted(true);
    } else {
      setListDeleted("");
      setBtnDeleted(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      name: record.name,
    }),
  };

  const [value, setValue] = useState([""]);

  const deleteBlog = (record) => {
    const data = {
      ids: [record.id],
    };
    confirm({
      title: "Bạn có muốn xóa bài viết này không?",
      onOk() {
        blogApi
          .deleteBlog(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công bài viết");
              getBlog();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const deleteBlogs = () => {
    const data = {
      ids: listDeleted,
    };
    confirm({
      title: "Bạn có muốn xóa các bài viết này không?",
      onOk() {
        blogApi
          .deleteBlog(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công các bài viết");
              getBlog();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const onChangeSelect = (newValue) => {
    console.log(newValue);
    setValue(newValue);
  };

  return (
    <>
      <div className="tabled">
        <Card>
          <Row gutter={16}>
            <Col span={6}>
              <label> Tên bài viết</label>
              <br />
              <Input
                addonAfter={<SearchOutlined />}
                defaultValue={inputFilter.name}
                placeholder="Nhập tên bài viết..."
                onChange={getCateDebounce}
                style={{
                  width: "100%",
                }}
              />
            </Col>

            <Col span={6}>
              <label className="">Chuyên mục</label>
              <TreeSelect
                treeLine={
                  treeLine && {
                    showLeafIcon,
                  }
                }
                style={{
                  width: "100%",
                }}
                dropdownStyle={{
                  maxHeight: 400,
                  overflow: "auto",
                }}
                value="0"
                treeData={categorySelect}
                onChange={(e) => {
                  if (e !== "0") {
                    setFilter({ ...inputFilter, page: 1, category: e });
                  } else {
                    const { category, ...list } = inputFilter;
                    setFilter(list);
                  }
                }}
              ></TreeSelect>
            </Col>
            <Col span={6}>
              <label className="">Trạng thái</label>
              <br />

              <Select
                // value={inputFilter.role}
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                defaultValue="createdAt:desc"
                onChange={(e) => {
                  setFilter({ ...inputFilter, page: 1, published: e });
                }}
              >
                <Option value="createdAt:desc">--- Mặc định ---</Option>
                <Option value="true">Hoạt động</Option>
                <Option value="false">Không hoạt động</Option>
              </Select>
            </Col>
            <Col span={6}>
              <label className="">Lượt xem</label>
              <br />

              <Select
                // value={inputFilter.role}
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                defaultValue=""
                onChange={(e) => {
                  setFilter({ ...inputFilter, page: 1, sortBy:  e});
                }}
              >
                <Option value="">--- Mặc định ---</Option>
                <Option value="view:desc">Cao đến thấp</Option>
                <Option value="view:asc">Thấp đến cao</Option>
              </Select>
            </Col>
          </Row>
        </Card>
        <br />
        <Space size={10}>
          <Link to="/article/add">
            <Button type="dashed" size="small">
              <EditOutlined /> &nbsp; Thêm bài viết
            </Button>
          </Link>

          {btnDeleted ? (
            <Button
              value="small"
              type="primary"
              icon={<AiFillDelete />}
              danger
              onClick={() => {
                deleteBlogs();
              }}
            >
              &nbsp;Xóa các bài viết được chọn
            </Button>
          ) : null}
        </Space>
        <br />
        <br />
        <Card
          bordered={true}
          className="criclebox tablespace mt-10 mb-24"
          //   title="Quản lý user hệ thống"
        >
          <div className="table-responsive">
            <Table
              rowSelection={{
                ...rowSelection,
              }}
              rowKey={(record) => record.id.toString()}
              loading={loading}
              onChange={onChange}
              columns={columns}
              dataSource={lstBlog}
              bordered
              className="ant-border-space"
              pagination={{
                pageSize: pageSize,
                total: totalCountBlog,
                pageSizeOptions: ["10", "50", "100", "200"],
              }}
            />
          </div>
        </Card>
      </div>
    </>
  );
};

export default Article;
